<template>
  <v-tab
    ref="tabRef"
    width="100%"
    class="text-none text-truncate rounded-lg"
    :class="{
      'pl-8': indentLevel === 1,
      'pl-12': indentLevel === 2,
      'small-text': indentLevel === 2,
    }"
    @click="emit('click')"
    @mouseenter="checkTruncation"
    @mouseleave="showTooltip = false"
  >
    <!-- Add a ref to the text element -->
    <div ref="textRef" class="text-truncate" :style="{ maxWidth: `${textWidth}px` }">
      {{ tabTitle }}
    </div>

    <!-- Example: Show a tooltip only if the text is truncated -->
    <v-tooltip
      v-model="showTooltip"
      activator="parent"
      :open-on-hover="false"
      location="right"
      content-class="bg-pwt_platinum"
    >
      {{ tabTitle }}
    </v-tooltip>
  </v-tab>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, type ComponentPublicInstance } from 'vue';

const { tabTitle, indentLevel = 0 } = defineProps<{
  tabTitle: string
  indentLevel?: 0 | 1 | 2
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()

const showTooltip = ref(false)

const tabRef = ref<ComponentPublicInstance | null>(null)
const textRef = ref<HTMLDivElement | null>(null)
const textWidth = ref(0)

let resizeObserver: ResizeObserver | undefined

onMounted(() => {
  const tab = tabRef.value?.$el

  if (!(tab instanceof HTMLElement)) return

  resizeObserver = new ResizeObserver(([entry]) => {
    if (!entry) return

    textWidth.value = entry.contentRect.width
  })

  resizeObserver.observe(tab)
})

onUnmounted(() => {
  resizeObserver?.disconnect()
})

const checkTruncation = () => {
  if (textRef.value) {
    // Check if total content width exceeds visible container width
    const isCutOff = textRef.value.scrollWidth > textRef.value.clientWidth
    // Only engage tooltip state if truncation is true
    showTooltip.value = isCutOff
  }
}
</script>

<style scoped>
.small-text {
  font-size: 13px;
}
</style>
